export const CheckIcon = ({ fill="#79838E", ...props }) => {
  return (
    <svg {...props} width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8.5" cy="8" r="7.5" stroke={fill} strokeOpacity="0.5" />
      <path d="M12.3326 5.67575C12.5558 5.91009 12.5558 6.29066 12.3326 6.525L7.76169 11.3242C7.5385 11.5586 7.17604 11.5586 6.95285 11.3242L4.66739 8.92462C4.4442 8.69028 4.4442 8.30972 4.66739 8.07538C4.89058 7.84104 5.25304 7.84104 5.47623 8.07538L7.35816 10.0494L11.5256 5.67575C11.7487 5.44142 12.1112 5.44142 12.3344 5.67575H12.3326Z" fill={fill} fillOpacity="0.5" />
    </svg>
  );
}